import React, { useState, useEffect } from 'react';
import './portfolio.css';
import axios from 'axios';
import IMG1 from '../../assets/static-projects/portfolio1.jpeg';
import IMG2 from '../../assets/static-projects/portfolio2.jpeg';
import IMG3 from '../../assets/static-projects/portfolio3.png';
import { AiOutlineCloseCircle } from 'react-icons/ai';

// Componente de carregamento
const LoadingIndicator = () => (
  <>
    <div className="loading-indicator"><div className="loading-bar"></div></div>
    <div className="loading-indicator"><div className="loading-bar"></div></div>
    <div className="loading-indicator"><div className="loading-bar"></div></div>
  </>
);

const Portfolio = () => {
  const [projects, setProjects] = useState([]);
  const [visibleProjects, setVisibleProjects] = useState(3);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  // Responsividade: define quantos projetos são visíveis inicialmente
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 1200) setVisibleProjects(6);
      else if (width >= 768) setVisibleProjects(4);
      else if (width >= 480) setVisibleProjects(2);
      else setVisibleProjects(1);
    };

    handleResize(); // Executa no início
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Primeira tentativa de carregar projetos da API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('http://127.0.0.1:5000/api/projects?sort=desc');
        setProjects(response.data);
        setIsLoading(false);
      } catch (error) {
        setHasError(true);
        setIsLoading(false);
        console.error('Erro ao obter projetos:', error);
      }
    };
    fetchData();
  }, []);

  // ✅ Verifica periodicamente se o servidor voltou após falha
  useEffect(() => {
    const interval = setInterval(async () => {
      if (hasError || projects.length === 0) {
        try {
          const res = await axios.get('https://apiportfoliov02.onrender.com/api/projects?sort=desc');
          if (res.status === 200 && res.data.length > 0) {
            setProjects(res.data);
            setHasError(false);
            setIsLoading(false);
            console.log("🔄 Projetos recarregados após retorno do servidor.");
          }
        } catch (err) {
          console.log("⛔ Servidor ainda fora do ar...");
        }
      }
    }, 5000); // tenta novamente a cada 5 segundos

    return () => clearInterval(interval);
  }, [hasError, projects.length]);

  // Loading
  if (isLoading) {
    return (
      <section id="portfolio">
        <h5>My Recent Work</h5>
        <h2>Portfolio</h2>
        <div className="container portfolio__container">
          <LoadingIndicator />
        </div>
      </section>
    );
  }

  // Fallback estático em caso de erro
  if (hasError || projects.length === 0) {
    return (
      <section id="portfolio">
        <h5>My Recent Work</h5>
        <h2>Portfolio</h2>
        <div className="container portfolio__container">
          <article className="portfolio__item">
            <div className="portfolio__item-image">
              <img src={IMG1} alt="Portfólio Abílio" />
            </div>
            <h3>Portfólio moderno baseado no perfil do autor</h3>
         
          </article>
          <article className="portfolio__item">
            <div className="portfolio__item-image">
              <img src={IMG2} alt="Página Inicial - Infinity" />
            </div>
            <h3>Landing page para plataforma de e-commerce</h3>
          
          </article>
          <article className="portfolio__item">
            <div className="portfolio__item-image">
              <img src={IMG3} alt="SoundOn Layout" />
            </div>
            <h3>Landing Page para plataforma de streaming SoundOn</h3>
           
          </article>
        </div>
        <h3 id="msg_err">Erro ao carregar projetos do banco de dados<br/>Aproveite o conteúdo estático</h3>
      </section>
    );
  }

  // Conteúdo com dados dinâmicos carregados
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {projects.slice(0, visibleProjects).map((project) => (
          <article key={project._id} className="portfolio__item">
            <div className="portfolio__item-image">
              <img src={project.image_url} alt={project.title} />
            </div>
            <h3>{project.title}</h3>
            <article>{project.description}</article>
            <div className="portfolio__item-cta">
  {project.github && (
    <a href={project.github} className="btn" target="_blank" rel="noreferrer">Github</a>
  )}
  {project.demo && (
    <a href={project.demo} className="btn btn-primary" target="_blank" rel="noreferrer">Demo</a>
  )}
</div>

          </article>
        ))}
      </div>

      <div className="ver-mais-container">
        <button className="btn btn-primary ver-mais" onClick={() => setShowPopup(true)}>Ver Mais</button>
      </div>

      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={() => setShowPopup(false)}>
              <AiOutlineCloseCircle />
            </button>
            {projects.map((project) => (
              <article key={project._id} className="portfolio__item">
                <div className="portfolio__item-image">
                  <img src={project.image_url} alt={project.title} />
                </div>
                <h3>{project.title}</h3>
                <article>{project.description}</article>
                  <div className="portfolio__item-cta">
  {project.github && (
    <a href={project.github} className="btn" target="_blank" rel="noreferrer">Github</a>
  )}
  {project.demo && (
    <a href={project.demo} className="btn btn-primary" target="_blank" rel="noreferrer">Demo</a>
  )}
</div>
              </article>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default Portfolio;
